import React, { useState } from 'react';
import '../../../entrydoor.css';

const FrameColor = ({ value, onChange, label = 'Screen Frame Color', disabled = false }) => {
    const [selectedFrameColor, setSelectedFrameColor] = useState(value || "White");

    const handleFrameColorChange = (e) => {
        setSelectedFrameColor(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="FrameColor">{label}</label>
            <select
                disabled={disabled}
                id="FrameColor"
                value={selectedFrameColor}
                onChange={handleFrameColorChange}
            >
                <option value="white">White</option>
                <option value="lightgrey">Light Grey</option>
                <option value="brown">Brown</option>
                <option value="lightblue">Blue</option>
                <option value="purple">Purple</option>
                <option value="red">Red</option>
            </select>
        </div>
    );
};

export default FrameColor;
